import React, { useState } from "react";
import { db } from "../firebase"; 
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./Login.css";

export default function Login() {
  const [passcode, setPasscode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!passcode) {
      setError("Enter passcode");
      return;
    }

    try {
      const ref = doc(db, "settings", "passcodeDoc");
      const snap = await getDoc(ref);

      if (snap.exists()) {
        const savedPasscode = snap.data().passcode;

        if (savedPasscode === passcode) {
          navigate("/landing");  
        } else {
          setError("Invalid passcode");
        }
      } else {
        setError("Passcode not found in database");
      }

    } catch (err) {
      setError("Error fetching passcode");
      console.error(err);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <h2 className="login-title">🔐 Login</h2>

        <input
          type="password"
          className="login-input"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          placeholder="Enter Passcode"
        />

        <button className="login-button" onClick={handleLogin}>
          Login
        </button>

        {error && <p className="error-text">{error}</p>}
      </div>
    </div>
  );
}